import { assertIsNonEmptyString } from './assertions';

export default class NonEmptyText {
	public get value(): string {
		return this.#value;
	}

	#value: string;

	public constructor(value: string) {
		assertIsNonEmptyString(value);
		this.#value = value;
	}
}
